<lib-page-layout>
  <lib-title-navbar pageHeader title="Osiągnięcia"></lib-title-navbar>

  <div class="or-px-20-px or-pt-24-px">
    <div class="or-head-md or-mb-12-px">Zdobyte ({{ earnedTrophies().length }})</div>

    @if (earnedTrophies().length) {
      @for (trophy of earnedTrophies(); track trophy) {
        <div class="or-d-flex or-align-items-center or-mb-12-px">
          <img [src]="trophiesMapper[trophy].icon" class="or-d-flex or-align-self-start or-mr-8-px" />
          <div>
            <div class="or-head-sm or-mb-4-px">{{ trophiesMapper[trophy].name }}</div>
            <div class="or-text-sm or-color-secondary-6">{{ trophiesMapper[trophy].description }}</div>
          </div>
        </div>
      }
    } @else {
      <div class="or-text-sm or-color-secondary-2 or-mb-8-px">
        Nie masz jeszcze żadnych osiągnięć. Zdobądź je grając i organizując gierki!
      </div>
    }

    @if (availableTrophies().length) {
      <div class="or-head-md or-mt-24-px or-mb-12-px">Dostępne ({{ availableTrophies().length }})</div>

      @for (trophy of availableTrophies(); track trophy) {
        <div class="or-d-flex or-align-items-center or-mb-12-px" style="opacity: 0.45">
          <img [src]="trophiesMapper[trophy].icon" class="or-d-flex or-align-self-start or-mr-8-px" />
          <div>
            <div class="or-head-sm or-mb-4-px">{{ trophiesMapper[trophy].name }}</div>
            <div class="or-text-sm or-color-secondary-6">{{ trophiesMapper[trophy].description }}</div>
          </div>
        </div>
      }
    }
  </div>

  <lib-bottom-navbar pageFooter></lib-bottom-navbar>
</lib-page-layout>
